import { ErrorResponse, trackGraphQlError } from './errorUtils';

export const newrelic = {
  addPageAction: (name: string, value: string | object) => {
    if (
      typeof window !== 'undefined' &&
      window.newrelic?.addPageAction instanceof Function
    ) {
      window.newrelic.addPageAction(name, value);
    }
  },
};

export const logNewRelicAction = (action: string, error?: ErrorResponse) => {
  newrelic.addPageAction(action, {
    ...(error
      ? { ...trackGraphQlError(error), result: 'error' }
      : { result: 'success' }),
  });
};

type NewRelicActions = {
  TOKEN_REQ: string;
  LOAD: string;
  REMOTE_AUTH_CALL: string;
  SUBMIT: string;

  ERR_CODE: string;
  ERR_MSG: string;

  PAYMENT: string;
  ADDRESSES: string;
  PROFILE: string;
  ZIPCODE: string;

  ENROLLMENT: string;
  ADD_ADDRESS: string;
  EDIT_ADDRESS: string;
  UPDATE_PROFILE: string;
  ADD_PAYMENT: string;
  EDIT_PAYMENT: string;
  EDIT_DELIVERY_DETAILS: string;
};

export function createNewRelicActions(currentView: string) {
  const lowerCaseView = currentView.toLowerCase();
  return {
    // orangePay events
    TOKEN_REQ: `ic-pcir-${lowerCaseView}-token-requested`,
    LOAD: `ic-pcir-${lowerCaseView}-load`,
    REMOTE_AUTH_CALL: `ic-pcir-${lowerCaseView}-remote-auth-call`,
    SUBMIT: `ic-pcir-${lowerCaseView}-submit`,

    ERR_CODE: `ic-pcir-${lowerCaseView}-error-code`,
    ERR_MSG: `ic-pcir-${lowerCaseView}-error-message`,

    // myAccount retrieve queries
    PAYMENT: `ic-pcir-${lowerCaseView}-get-payments`,
    ADDRESSES: `ic-pcir-${lowerCaseView}-get-addresses`,
    PROFILE: `ic-pcir-${lowerCaseView}-get-profile`,
    ZIPCODE: `ic-pcir-${lowerCaseView}-get-city-by-zipcode`,

    // myAccount mutation queries
    ENROLLMENT: `ic-pcir-${lowerCaseView}-enrollment`,
    ADD_ADDRESS: `ic-pcir-${lowerCaseView}-add-address`,
    EDIT_ADDRESS: `ic-pcir-${lowerCaseView}-edit-address`,
    UPDATE_PROFILE: `ic-pcir-${lowerCaseView}-update-profile`,
    ADD_PAYMENT: `ic-pcir-${lowerCaseView}-add-payment`,
    EDIT_PAYMENT: `ic-pcir-${lowerCaseView}-edit-payment`,
    EDIT_DELIVERY_DETAILS: `ic-pcir-${lowerCaseView}-edit-delivery-details`,
  } as const satisfies NewRelicActions;
}
